import { FC } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@mui/material';
import { useField, useFormikContext } from 'formik';

export interface AutoCompleteOption {
  id: string;
  label: string;
}

export interface AutoCompleteInputProps {
  name: string;
  label?: string;
  options: AutoCompleteOption[];
}

export const AutoCompleteInput: FC<AutoCompleteInputProps> = ({ name, label, options }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const hasError = meta.touched && Boolean(meta.error);

  return (
    <FormControl fullWidth error={hasError}>
      {label && <InputLabel>{label}</InputLabel>}
      <Select native value={field.value || ''} label={label} onChange={(e) => setFieldValue(name, e.target.value)} displayEmpty>
        <option value="" disabled>
          Select an option
        </option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </Select>
      {hasError && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};
